const getChannelInitials = (string) => {
  if (!string) {
    return '';
  }
  return string.split(' ').map(word => word[0].toUpperCase()).join('');
}

export default getChannelInitials;
